import React from "react";
import Select from "react-select";
import { Modal, Spinner } from "reactstrap";

const CloseClassModal = ({ show, loading, formData3, setFormData3, timeSlots, attendanceTakenSlots, onSubmit, onClose }) => {
  if (!show) return null;

  const slotOptions = [
    {
      value: "ALL",
      label: "All Slots",
      isDisabled: attendanceTakenSlots.length > 0,
    },
    ...timeSlots.map((slot) => {
      const isClosedClass = Number(slot.IsClassCancelled) === 1;
      const isAttendanceTaken = attendanceTakenSlots.includes(slot.Batch_Time);

      return {
        value: slot.Batch_Time,
        label: `${slot.Batch_Time}${isClosedClass ? " (Closed Class)" : ""}`,
        isDisabled: isClosedClass || isAttendanceTaken,
      };
    }),
  ];


  return (
    <Modal isOpen={show} toggle={onClose} backdrop="static" keyboard={false}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title">
            Close Class
          </h5>

          <button
            type="button"
            className="btn-close"
            onClick={onClose}
          />
        </div>

        <div className="modal-body">
          {loading ? (
            <div className="text-center my-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <div className="mb-3">
                <label className="form-label">
                  Batch Time*
                </label>
                <Select
                  placeholder="Select Batch"
                  options={slotOptions}
                  value={
                    slotOptions.find(
                      (option) =>
                        option.value === formData3.batchTime
                    ) || null
                  }
                  isOptionDisabled={(option) => option.isDisabled}
                  onChange={(selectedOption) =>
                    setFormData3({
                      ...formData3,
                      batchTime: selectedOption?.value || "",
                    })
                  }
                  required
                  isClearable
                  classNamePrefix="select2-selection"
                />
              </div>

              <div className="mb-3">
                <label className="form-label">
                  Reason*
                </label>

                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Enter reason"
                  value={formData3.reason || ""}
                  onChange={(e) =>
                    setFormData3({
                      ...formData3,
                      reason: e.target.value,
                    })
                  }
                  required
                />
              </div>
              <div className="form-check mb-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="CompOff"
                  checked={!!formData3.isCompGiven}
                  onChange={(e) =>
                    setFormData3({
                      ...formData3,
                      isCompGiven: e.target.checked,
                    })
                  }
                />
                <label className="form-check-label" htmlFor="CompOff">
                  Give Comp
                </label>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
          >
            Close
          </button>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CloseClassModal;